<template>
  <div class="production_wrap">
    <div class="production_img"  id="cpjz">
<!--      <img src="../../assets/img/product/product_banner.jpg" width="100%" alt="" />-->
      <div class="production_img_inner">
        <div class="img_desc hidden-xs-only">制造业转型升级的一站式引擎</div>
        <div class="img_tit">全链智控，数造未来</div>
        <div class="img_desc hidden-sm-and-up">制造业转型升级的一站式引擎</div>
        <div class="img_desc hidden-xs-only">从设计到交付，数字化全链贯通，一站式数字化制造服务，让效率与质量双擎驱动</div>
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="产品矩阵" name="first"></el-tab-pane>
        <el-tab-pane label="产品特点" name="second"></el-tab-pane>
        <el-tab-pane label="服务范畴" name="third"></el-tab-pane>
        <el-tab-pane label="改造方向" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="production_title_wrap"  >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title " >产品矩阵</div>
        </div>
      </div>
    </div>
    <div class="mobile_area hidden-sm-and-up">
      <img src="../../assets/img/mobile/chanpinjuzhen.png"  style="width: 100%;" />
    </div>
    <div class="production_box hidden-xs-only" >
      <div class="production_item">
        <div class="item-area">
          <div class="top-btn">
            企业层(战略与资源管理)
          </div>
          <div :class="currentSub!==''&&currentSub!=='12'&&currentSub!=='13'?'sub-item-hover':'sub-item'" @mousemove="overSub('0')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-1-1.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/erp').catch(() => {})">企业资源计划管理(ERP)</el-button>
            <p>统一管理财务、采购、销售、生产计划</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='1'?'sub-item-hover':'sub-item'" @mousemove="overSub('1')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-1-2.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/plm').catch(() => {})">产品生命周期管理(PLM)</el-button>
            <p>产品设计数据管理、BOM传递至ERP/MES</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='2'||currentSub==='8' ?'sub-item-hover':'sub-item'" @mousemove="overSub('2')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-1-3.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/aps').catch(() => {})">高级计划排程(APS)</el-button>
            <p>动态生产排程，联动ERP与MES</p>
          </div>
        </div>
      </div>
      <div class="production_item">
        <div class="item-area">
          <div class="top-btn">
            决策层(数据驱动决策)
          </div>
          <div :class="currentSub==='0'||currentSub==='3'?'sub-item-hover':'sub-item'" @mousemove="overSub('3')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-2-1.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/sjzt').catch(() => {})">数据中台</el-button>
            <p>整合ERP、MES、WMS等系统数据</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='4'?'sub-item-hover':'sub-item'" @mousemove="overSub('4')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-2-2.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/dsjfx').catch(() => {})">大数据分析平台</el-button>
            <p>生产效能分析、质量预测、供应链优化</p>
          </div>
          <div class="sub-item" @mousemove="overSub('')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-2-3.png" />
            <el-button round class="sub-item-btn1" disabled >AI模型库</el-button>
            <p>工艺参数优化、设备故障预警、需求预测</p>
          </div>
        </div>
      </div>
      <div class="production_item">
        <div class="item-area">
          <div class="top-btn">
            协同层(外部生态集成)
          </div>
          <div :class="currentSub==='0'||currentSub==='5'?'sub-item-hover':'sub-item'" @mousemove="overSub('5')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-3-1.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/srm').catch(() => {})">供应商关系管理(SRM)</el-button>
            <p>管理供应商协同、采购需求预测</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='6'?'sub-item-hover':'sub-item'" @mousemove="overSub('6')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-3-2.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/crm').catch(() => {})">客户关系管理(CRM)</el-button>
            <p>客户订单跟踪、需求分析</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='7'?'sub-item-hover':'sub-item'" @mousemove="overSub('7')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-3-3.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/scm').catch(() => {})">供应链管理(SCM)</el-button>
            <p>物流路径优化、多级库存协同</p>
          </div>
        </div>
      </div>
      <div class="production_item">
        <div class="item-area">
          <div class="top-btn">
            管控层(生产与运营执行)
          </div>
          <div :class="currentSub==='0'||currentSub==='2'||currentSub==='8'||currentSub==='12'?'sub-item-hover':'sub-item'" @mousemove="overSub('8')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-4-1.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/mes').catch(() => {})">制造执行系统(MES)</el-button>
            <p>车间任务调度、设备监控、生产数据采集</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='9'?'sub-item-hover':'sub-item'" @mousemove="overSub('9')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-4-2.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/wms').catch(() => {})">仓库管理系统(WMS)</el-button>
            <p>自动化出入库与MES协同物料配送</p>
          </div>
          <div :class="currentSub==='0'||currentSub==='10'||currentSub==='13'?'sub-item-hover':'sub-item'" @mousemove="overSub('10')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-4-3.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/qms').catch(() => {})">质量管理系统(QMS)</el-button>
            <p>质检、质量数据追溯、与MES联动缺陷分析</p>
          </div>
        </div>
      </div>
      <div class="production_item">
        <div class="item-area">
          <div class="top-btn">
            现场层(设备与物流管控)
          </div>
          <div :class="currentSub==='0'||currentSub==='11'?'sub-item-hover':'sub-item'" @mousemove="overSub('11')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-5-1.png" />
            <el-button round class="sub-item-btn" @click="$router.push('/Solutions/wrzs').catch(() => {})">无人值守计量节点</el-button>
            <p>自动计量、实时监测、数据远程传输与异常报警</p>
          </div>
          <div :class="currentSub==='8'||currentSub==='12'?'sub-item-hover':'sub-item'" @mousemove="overSub('12')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-5-2.png" />
            <el-button round class="sub-item-btn1" disabled>PLC控制器</el-button>
            <p>生产线自动化控制、实时数据采集</p>
          </div>
          <div :class="currentSub==='10'||currentSub==='13'?'sub-item-hover':'sub-item'" @mousemove="overSub('13')" @mouseout="outSub()">
            <img src="../../assets/img/product/item-5-3.png" />
            <el-button round class="sub-item-btn1" disabled>工业传感器</el-button>
            <p>设备互联、传感器数据上传至数据中心</p>
          </div>
        </div>
      </div>

    </div>
    <div class="basic-area hidden-xs-only" id="cptd" >
      <div class="title">
        基础设施层(硬件支撑)
      </div>
      <div class="content">
        <div class="content-item">网络<br>通讯</div>
        <div class="content-item">融合<br>通讯</div>
        <div class="content-item">安防<br>监控</div>
        <div class="content-item">物联<br>融合</div>
        <div class="content-item">数字<br>能源</div>
        <div class="content-item">信息<br>安全</div>
        <div class="content-item">数据<br>安全</div>
        <div class="content-item">数据<br>中心</div>
        <div class="content-item">私有云</div>
        <div class="content-item" >公有云</div>
      </div>
    </div>
    <div class="tedian" >
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">产品特点</div>
        </div>
      </div>
    </div>
      <div class="chanpintedian hidden-sm-and-up">
        <img src="../../assets/img/mobile/chanpintedian.png">
      </div>
    <div class="production_core_scene hidden-xs-only">
      <div class="production_core_scene_title">
        <span class="sub1">模块化</span>
        <img src="../../assets/img/product/line.png"/>
        <span class="sub2">让数字化从“负重前行”变为“轻装进化”</span>
      </div>
      <div class="mkh-item">
      <div class="item-bg"><img src="../../assets/img/product/bg.png"></div>
      <div class="item">
        <img class="bg" src="../../assets/img/product/point1.png">
        <span>模块自由配</span>
        模块自由选配<br>业务随增长而进化
        <img class="hx" src="../../assets/img/product/hengxian.png">
        <div class="btn-area">
          <div class="left-div">灵活扩展</div>
          <div class="right-div">随需应变</div>
        </div>
      </div>
      <div class="item">
        <img class="bg" src="../../assets/img/product/point2.png">
        <span>成本精准控</span>
        按需付费<br>告别“大而全”的浪费
        <img class="hx" src="../../assets/img/product/hengxian.png">
        <div class="btn-area">
          <div class="left-div">成本可控</div>
          <div class="right-div">投资精准</div>
        </div>
      </div>
      <div class="item">
        <img class="bg" src="../../assets/img/product/point3.png">
        <span>风险阶梯降</span>
        分步上线<br>转型风险降维管控
        <img class="hx" src="../../assets/img/product/hengxian.png">
        <div class="btn-area">
          <div class="left-div">风险分散</div>
          <div class="right-div">稳步升级</div>
        </div>
      </div>
      <div class="item">
        <img class="bg" src="../../assets/img/product/point4.png">
        <span>数据深度用</span>
        数据驱动<br>让每一分投入都精准发力
        <img class="hx" src="../../assets/img/product/hengxian.png">
        <div class="btn-area">
          <div class="left-div">资源聚焦</div>
          <div class="right-div">高效利用</div>
        </div>
      </div>
      </div>
    </div>
      <div class="production_card hidden-sm-and-up">
        <div class="title-div"><span class="title">一站式</span><img src="../../assets/img/product/line2.png"/><span class="desc">整合多元资源流程，提供全需高效解决方案</span></div>
      </div>
      <div class="chanpintedian hidden-sm-and-up">
        <img src="../../assets/img/mobile/yitihua.png">
      </div>
    <div class="production_card hidden-xs-only">
     <div class="title-div"><span class="title">一站式</span><img src="../../assets/img/product/line2.png"/><span class="desc">整合多元资源与流程，提供覆盖全需求的高效便捷解决方案</span></div>
      <div class="item-content" id="fwfc">
        <div class="sub-item-yzs">
          <div class="up-card"><img  src="../../assets/img/product/yzs-1.png"/>高效省时</div>
          <div class="down-card">全流程服务，告别多端对接，资源优化一步到位！</div>
        </div>
        <div class="sub-item-yzs">
          <div class="up-card"><img  src="../../assets/img/product/yzs-2.png"/>深度定制</div>
          <div class="down-card">软件&数据中心，按需设计，灵活扩展，精准匹配业务场景！</div>
        </div>
        <div class="sub-item-yzs">
          <div class="up-card"><img  src="../../assets/img/product/yzs-3.png"/>专业护航</div>
          <div class="down-card">跨领域技术团队+行业经验，携手多元生态，品质保障！</div>
        </div>
        <div class="sub-item-yzs">
          <div class="up-card"><img  src="../../assets/img/product/yzs-4.png"/>成本可控</div>
          <div class="down-card">集约化部署+绿色节能，降本增效看得见！ </div>
        </div>
        <div class="sub-item-yzs" style="margin-right: 0">
          <div class="up-card"><img  src="../../assets/img/product/yzs-5.png"/>安全无忧</div>
          <div class="down-card">数据加密+智能运维，7×24小时守护您的核心资产！</div>
        </div>

      </div>
    </div>
    </div>
    <div class="service-card"  >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">服务范畴</div>
          <div class="production_desc">轻量化解决方案，帮助企业实现“合规生产、柔性试制”</div>
        </div>
      </div>
      <Accordion class="hidden-xs-only"/>
      <div class="mobile-img hidden-sm-and-up">
        <img src="../../assets/img/mobile/fuwufanchou.png" />
      </div>
      <span id="gzfx"></span>
    </div>
    <div class=" hidden-sm-and-up" style="background-color: #F5F7FA">
      <img src="../../assets/img/mobile/gaizaofangxiang.png" style="width: 100%"/>
    </div>
    <div class="tedian hidden-xs-only">
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">改造方向</div>
          </div>
        </div>
        <div class="production_card">

        <img src="../../assets/img/product/gaizao.png" class="gaizao"/>
      </div>
      </div>
    </div>
    <div class="tedian padding80 hidden-xs-only" >
      <Zixun />
    </div>
    <div class="tedian hidden-sm-and-up" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import Accordion from './accordion.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
    Accordion

  },
  mounted() {
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        this.activeName="first"
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 1100){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 2100){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 3000){
          this.activeName="fourth"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
    // let cpjzElements = document.getElementByld('cpjz');
    // cpjzElements.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'start'
    // })
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('cptd');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tedian{
  background-color:#F5F7FA;
  padding: 5px 0 0 0 ;
}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  .production_img {
    width: 100%;
    //cursor: pointer;
    height: 420px;
    background: url('../../assets/img/product/product_banner.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    position: relative;
    @media screen and (max-width: 768px) {
      height: 40vw;
    }
    .img_tit {
      font-size: 40px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    .img_desc {
      font-size: 20px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.9rem;
      }
    }
    .img_btn {
      width: 150px;
      height: 40px;
      margin-top: 20px;
      background: #00A4FF;
      color: #fff;
      bottom: 15%;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 14px;
      &:hover {
        color: #fff;
        font-weight: bold;
        background: #24b1ff;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 28px;
        font-size: 0.8rem;
        border-radius: 2PX;
        margin-top: 10PX;
      }
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      background-color: rgba(245, 247, 250, 1);
      margin-top: 0;
      padding-top: 15PX;
    }
  }
  .production_inner {
    display: flex;
    justify-content: center;
    .inner_center {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }
      .production_title {
        color: #05102F;
        font-size: 33px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1.1rem;
        }
      }
      .production_desc {
        font-size: 16px;
        color: #253554;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
  }
  .production_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .production_item {
      width: calc(100% / 5 - 16px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      display: flex;
      @media screen and (max-width: 768px) {
        width: 90%;
        margin-left: 0;
        margin-top: 20px;
      }
      .item-area{
        border-radius: 8px;
        background: linear-gradient(0deg, #F6F8FF 0%, #D9E6FA 100%);
        border: 2px dashed #a3c4fe;
        width: 100%;
        height: 100%;
        padding: 15px 8px;
        .top-btn{
          border-radius: 8px;color: #fff;
          background: #3393FD;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          line-height: 40px;
          font-size: 16px;
        }
        .sub-item-hover{
          border-radius: 8px;
          margin-top: 15px;
          background: linear-gradient(180deg, #4791FF 16.67%, #FFFFFF 100%);;
          padding: 20px 5px  10px 5px;
          border: 2px dashed #5986D5;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        .sub-item{
          border-radius: 8px;
          margin-top: 15px;
          background: linear-gradient(0deg, #F6F8FF 0%, #D9E6FA 100%);
          padding: 20px 5px  10px 5px;
          border: 2px dashed #5986D5;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        img{
          width: 40%;
        }
        .sub-item-btn1 {
          margin-top: 10px;
          border: 0;
          color: #05102F;
          width: 100%;
        }
        .sub-item-btn {
          margin-top: 10px;
          border: 0;color:#05102F;width: 100%;
          &:hover{
            background-color: #3393FD;
            color: #fff;
          }
        }
        p{
          font-size: 10px;
          line-height: 40px;
          color: #8491AB;
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      @media screen and (max-width: 768px) {
        padding-top: 10PX;
      }
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;

      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
        @media screen and (max-width: 768px) {
          font-size: 1.1rem;
      }

      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
        }

      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
            .up-card{
              color: #0052D9;
            }
        }
      }

      }
    }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      font-size: 14px;
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    height: 60px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .mkh-item{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    //padding: 0 20px;
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    line-height: 20px;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 12px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 12px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
   color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
.mobile_area{
  background-color: #F5F7FA;
  padding-top: 15PX;
}
.chanpintedian{
  background-color: #F5F7FA;
  padding-top: 15PX;
  text-align: center;
  img{
    width: 95%;
  }
}
.mobile-img{
  width: 95%;
  margin: 20PX auto;
  img{
    width: 100%;
  }
}
</style>